var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#117FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.904 5.81165L10.1481 13.6529H7.31194L9.49163 10.0546H7.32544L4.79981 14.2193C6.00376 15.198 7.51019 15.7283 9.06172 15.7195C10.6132 15.7108 12.1136 15.1635 13.3064 14.1713C14.4992 13.179 15.3105 11.8034 15.6015 10.2794C15.8926 8.75538 15.6455 7.17759 14.9023 5.81559L14.904 5.81165ZM10.7516 4.40428L8.68725 7.80178H10.8562L13.2604 3.83672C12.0564 2.85803 10.55 2.32776 8.99847 2.33653C7.44694 2.3453 5.9466 2.89255 4.75379 3.88479C3.56099 4.87702 2.74974 6.25266 2.45865 7.77667C2.16757 9.30067 2.41472 10.8785 3.15788 12.2405L7.91213 4.40484H10.7511L10.7516 4.40428Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHight);
export default __webpack_public_path__ + "static/media/hight.171055477a2f43f454b9ccfb49f79b3b.svg";
export { ForwardRef as ReactComponent };